import { render, staticRenderFns } from "./TablePeople.vue?vue&type=template&id=3aae7031&scoped=true&"
import script from "./TablePeople.vue?vue&type=script&lang=js&"
export * from "./TablePeople.vue?vue&type=script&lang=js&"
import style0 from "./TablePeople.vue?vue&type=style&index=0&id=3aae7031&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae7031",
  null
  
)

export default component.exports